import React , {useState , useEffect} from 'react';
import Footer from '../components/Footer';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import TeamWork from '../components/HomeComponents/TeamWork';
import MostFunctionality from '../components/HomeComponents/MostFunctionality';
import SuccessPartners from '../components/HomeComponents/SuccessPartners';
import Aos from 'aos';
import "aos/dist/aos.css";



const About = () => {

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


  const [showSlideMenu , setShowSlideMenu] = useState(false);
  
  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="main_homepage" >

    
    <NavbarHome />

    <div className="advertistments_heroarea mt-1" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"  > 
  


      <div className="single_advert_section" style={{   background: `linear-gradient(  rgba(0,0,0,0.4) , #010101 ) , url('/images/heroarea/3.jpg') center / cover `  }}  >

      <div className="content_heroarea">
        <img src="/images/icons/logo.png" alt="" className="heroarea_logo" />
        <h1 className="heroarea_headline">  البوصلة السياحية </h1>
        <h1 className="heroarea_subheadline">  معلومات عن فريقنا </h1>

        <button className="btn_shopping p-2 w-30 mt-1" onClick={() =>  window.scrollTo(750 , 750) } >     تعرف علينا أكثر </button>
      </div>
      </div>

  
    </div>

   


    <MostFunctionality />

    <TeamWork />

    <SuccessPartners />

 

    {/* <div className="section most_features_section container-mid">

<div className="d-flex-c">

<div className="info_box"></div>
<h1 className="main_headline">   شركاؤونا المرشدين </h1>
</div>

<div className="d-flex-c f-sp f-wrap features_icons section">

  <div className="single_feature_div">
    <img src="https://cdn-icons-png.flaticon.com/512/9495/9495481.png" alt="" />
    <h1 className="headline_feaure_info">  محمد الحارثي </h1>
    <h1 className="subheadline_feaure_info">    مرشد سياحي </h1>
    <p className="main_para">مرشد سياحي وهايك محمد الحارثي</p>
  </div>

  <div className="single_feature_div">
    <img src="https://cdn-icons-png.flaticon.com/512/9495/9495481.png" alt="" />
    <h1 className="headline_feaure_info">   افغان لاميان </h1>
    <h1 className="subheadline_feaure_info">    مرشد سياحي </h1>
    <p className="main_para">     مرشد مهتم بالأنشطة السياحية </p>
  </div>



</div>

</div> */}

    {/* <div className="section most_features_section container-mid">

<div className="d-flex-c">

<div className="info_box"></div>
<h1 className="main_headline">   شركاؤونا المصورين </h1>
</div>

<div className="d-flex-c f-sp f-wrap features_icons section">

  <div className="single_feature_div">
    <img src="https://cdn-icons-png.flaticon.com/512/2317/2317973.png" alt="" />
    <h1 className="headline_feaure_info">   أيمن رحماني </h1>
    <h1 className="subheadline_feaure_info">    مصور فوتوغرافي  </h1>
    <p className="main_para"> حاب تشوف أفكارك على أرض الواقع ؟ </p>
  </div>

  <div className="single_feature_div">
    <img src="https://cdn-icons-png.flaticon.com/512/2317/2317973.png" alt="" />
    <h1 className="headline_feaure_info">    مؤمن طلال
 </h1>
    <h1 className="subheadline_feaure_info">     مصور فوتوغرافي   </h1>
    <p className="main_para">        اشارك رحلتي لأكون مصور فيديو افضل 🥇📷 اساعدك تتعلم تصوير وتكسب منه فلوس 💵🎬

</p>
  </div>



</div>

</div> */}



    <Footer />

    </div>
  )
}

export default About